import { render, staticRenderFns } from "./caseRetail.vue?vue&type=template&id=659876e6&"
import script from "./caseRetail.js?vue&type=script&lang=js&"
export * from "./caseRetail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports